import React from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../utils/colors';
import ScrollIndicator from './shared/ScrollIndicator';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const NotesPage = () => {
  // Use our custom hook to apply random colors to all links
  useRandomLinkColors();
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/iUnLy8cW2gaXAuiSATVKPc/Madeleine_Morlet_1.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/qNwd5ogyApKECozDaDR8Vj/Madeleine_Morlet_2.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/64Sazqb7VLEmnpAo1BqKxh/Madeleine_Morlet_3.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/gD7JQ22zm1S3xb3RVNx1dy/Madeleine_Morlet_4.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/ddYhiez1tbvbMqpQtuX78v/Madeleine_Morlet_5.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/4nefeA3jqe4DjNRZcwhfBs/Madeleine_Morlet_6.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/doQtfgYpv729rhbJws6Boz/Madeleine_Morlet_7.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/48Fw2mWL8s1NcVvg2FmY2r/Madeleine_Morlet_8.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/wcoK1Sbi7FzwFTLNC2jYQA/Madeleine_Morlet_9.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/vRKdiDDna6CaBhR7fheKWk/Madeleine_Morlet_10.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/3Vzn6mXh63HBEzRXmDL36V/Madeleine_Morlet_11.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/79uwhDgB2WZR2PGBzwtqB9/Madeleine_Morlet_12.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/eyxQXqehcGpCBpiaFW6ABi/Madeleine_Morlet_13.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLhCg3uDFuvkZQsxvkHEht/Madeleine_Morlet_14.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/q3pUezZEhDjd9q2w7BwU6u/Madeleine_Morlet_15.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/2RVAZznpFSmUJeoRaEHXR6/Madeleine_Morlet_16.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/7JJUrem7CK2hrgBxPvvV87/Madeleine_Morlet_17.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/9kZE16xecD5dmvNkJxcu33/Madeleine_Morlet_18.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/mWQXyGyeSUcbNyMzoGH8Gi/Madeleine_Morlet_19.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/534AMoYryuqde7hV7Jnf2f/Madeleine_Morlet_20.jpg'];
  // Create a varied spacing array to make the layout more editorial
  const getSpacing = index => {
    const spacings = [6, 12, 8, 16, 10, 14, 7, 12, 9, 16, 10, 14];
    return spacings[index % spacings.length];
  };
  // Create a varied height array for more visual interest
  const getHeight = index => {
    const heights = ['70vh', '65vh', '75vh', '68vh'];
    return heights[index % heights.length];
  };
  const getImagePosition = (index: number) => {
    if (index === 0) return '16vh';
    const positions = ['20vh', '4vh', '24vh', '8vh', '28vh', '12vh', '16vh'];
    return positions[index % positions.length];
  };
  const getImageSize = (index: number) => {
    if (index === 0) return '70vh';
    const sizes = ['80vh', '65vh', '75vh', '70vh', '85vh'];
    return sizes[index % sizes.length];
  };
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-347" data-mp="37yc5ibom5hpi">
      <header className="fixed top-0 w-full flex justify-end px-6 py-6 z-10 bg-[#faf9f7]" data-id="element-348" data-mp="37w9a1c4oywde">
        <div className="flex space-x-6" data-id="element-349" data-mp="3cv2kswslg99v">
          <div className="text-base font-normal" data-id="element-350" data-mp="4h3t47cnna26">
            <Link to="/" className="transition-colors duration-200" onMouseEnter={e => {
            e.currentTarget.style.color = getRandomColor();
          }} onMouseLeave={e => {
            e.currentTarget.style.color = '#333333';
          }} data-id="element-351" data-mp="4fakimihefrj">
              Madeleine Morlet
            </Link>
          </div>
          <div className="text-base font-normal" data-id="element-352" data-mp="2fbj5jvj1smgk">
            <Link to="/info" className="transition-colors duration-200" onMouseEnter={e => {
            e.currentTarget.style.color = getRandomColor();
          }} onMouseLeave={e => {
            e.currentTarget.style.color = '#333333';
          }} data-id="element-353" data-mp="2k8rlrqkmygf6">
              Info
            </Link>
          </div>
        </div>
      </header>
      {/* Desktop Layout */}
      <div className="hidden md:block h-screen overflow-x-auto hide-scrollbar" data-id="element-354" data-mp="2londkjbsi5cb">
        <div className="flex min-w-max" data-id="element-355" data-mp="3jdqp271x5wp9">
          <div className="w-[33vw] pl-16 flex-shrink-0" style={{
          paddingTop: '24vh'
        }} data-id="element-356" data-mp="3efovgs6vaezj">
            <div className="text-base max-w-[360px] pr-4" data-id="element-357" data-mp="39ere2htoloz3">
              Field Notes (Ongoing)
            </div>
          </div>
          <div className="flex items-start" style={{
          paddingTop: '16vh'
        }} data-id="element-358" data-mp="34jlrdgsgg69y">
            {images.map((image, index) => <div key={index} className="flex-shrink-0" style={{
            marginRight: index === images.length - 1 ? 0 : `${getSpacing(index)}rem`
          }} data-id="element-359" data-mp="1t46xwmzgfwjl" data-mpi={index}>
                <img src={image} alt={`Notes - Image ${index + 1}`} className="w-auto object-contain" style={{
              height: getImageSize(index)
            }} data-id="element-360" data-mp="ih6fzfwja9um" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Mobile Layout */}
      <div className="md:hidden pt-20 px-6" data-id="element-361" data-mp="118z0sn1g8or9">
        <div className="mb-6" data-id="element-362" data-mp="1198r6bqeoxxh">
          <div className="text-base mb-4" data-id="element-363" data-mp="116wd49nrr7pp">Field Notes (Ongoing)</div>
        </div>
        <div className="w-full space-y-8" data-id="element-364" data-mp="1670qhqtdrmbp">
          {images.map((image, index) => <div key={index} className="w-full" data-id="element-365" data-mp="331n8b8l4lycu" data-mpi={index}>
              <img src={image} alt={`Notes - Image ${index + 1}`} className="w-full h-auto object-contain" data-id="element-366" data-mp="37yx6pdqhtkct" />
            </div>)}
        </div>
      </div>
      <ScrollIndicator data-id="element-367" data-mp="2vxxe7kuwtpyw" />
      <style jsx data-id="element-368" data-mp="2vyp023ypg9bz">{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
};
export default NotesPage;